export const groundOpsKey = (module, action = 'list') => `ground_ops.${module}.${action}`

export const groundOpsAccess = (module, action = 'list') => ({ mode: 'permissions', key: groundOpsKey(module, action) })
